import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-md-row justify-content-around mt-10" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-center flex-column" }
const _hoisted_3 = {
  style: {"width":"50px","position":"absolute","top":"0px","left":"0px"},
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary px-4 me-1 active rounded-pill"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "wordpress",
  src: "/media/plugins/wordpress.png",
  class: "w-75"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", { class: "text-primary mt-3" }, "وردپرس", -1)
const _hoisted_6 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_7 = { href: "https://www.inboxino.com/wp-content/inboxino.zip" }
const _hoisted_8 = {
  style: {"width":"50px"},
  class: "btn btn-sm text-nowrap btn-light-success d-flex flex-center mx-1 px-3"
}
const _hoisted_9 = {
  style: {"width":"50px"},
  class: "btn btn-sm text-nowrap btn-success d-flex flex-center mx-1 px-3"
}
const _hoisted_10 = { class: "d-flex align-items-center justify-content-center flex-column" }
const _hoisted_11 = {
  style: {"width":"50px","position":"absolute","top":"0px","left":"0px"},
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary px-4 me-1 active rounded-pill"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  alt: "wordpress",
  src: "/media/plugins/python.jpg",
  class: "w-75 mx-auto"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", { class: "text-primary mt-3" }, "پایتون", -1)
const _hoisted_14 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_15 = {
  style: {"width":"50px"},
  class: "btn btn-sm text-nowrap btn-success d-flex flex-center mx-1 px-3"
}
const _hoisted_16 = { class: "d-flex align-items-center justify-content-center flex-column" }
const _hoisted_17 = {
  style: {"width":"50px","position":"absolute","top":"0px","left":"0px"},
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary px-4 me-1 active rounded-pill"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  alt: "wordpress",
  src: "/media/plugins/php.png",
  class: "w-75 mx-auto"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", { class: "text-primary mt-3" }, "پی اچ پی", -1)
const _hoisted_20 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_21 = {
  style: {"width":"50px"},
  class: "btn btn-sm text-nowrap btn-success d-flex flex-center mx-1 px-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_card, {
        style: {"position":"relative"},
        class: "d-flex align-items-center justify-content-center flex-column col-12 col-md-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.translate("رایگان")), 1),
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", _hoisted_7, [
                _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.translate("download")), 1)
              ]),
              _createVNode(_component_router_link, { to: "/services/wpPlugin" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.translate("راهنما")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        style: {"position":"relative"},
        class: "d-flex align-items-center justify-content-center flex-column col-12 col-md-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.translate("رایگان")), 1),
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_router_link, { to: "/services/pythonPlugin" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.translate("راهنما")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        style: {"position":"relative"},
        class: "d-flex align-items-center justify-content-center flex-column col-12 col-md-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.translate("رایگان")), 1),
            _hoisted_18,
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_router_link, { to: "/services/phpPlugin" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_21, _toDisplayString(_ctx.translate("راهنما")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}